import { $get } from "@/utils/request";

// 获取对于教练类型奖励规则
export const getCycleAward = (biz_type: string) => {
  return $get(`/v1/coach/cycle_award`, { biz_type }).then((res: any) => res.data)
}